import apiInstance from "./apiInstance";
import { isNumber } from "lodash";
const addPersonel = (personel) => {
  return apiInstance.post("enpersonel", personel);
};

const addRoleToPersonel = (params) => {
  return apiInstance.post("/enpersonel/role", params);
};

const deleteRoleFromPersonnel = (params) => {
  const { userId, userRoleId } = params;
  return apiInstance.delete(`/enpersonel/role/${userId}/${userRoleId}`);
};

const editPersonelOperation = (params) => {
  return apiInstance.post("/enpersonel/operation", params);
};

const searchTeacher = (params) => {
  return apiInstance.post("/enpersonel/teacher/search", params);
};

const deletePersonnel = (params) => {
  return apiInstance.post("/enpersonel/remove", params);
};

const setStatus = (params) => {
  return apiInstance.post(`/enpersonel/setStatus`, params);
};

const getPersonelByDomainTypeAndDomainId = (params) => {
  const { domainType, domainId } = params;
  return apiInstance.post(`/enpersonel/getPersonelByDomainId/${domainType}/${domainId}`);
};

const getPersonelByDomainType = (domainType) => {
  return apiInstance.get(`/enpersonel/getPersonnelsByDomainType/${domainType}`);
};

const searchPersonel2 = () => {
  return apiInstance.post("/enpersonel/personel/search2");
};

const searchPersonel2ByStatus = (params) => {
  return apiInstance.post(
    `/enpersonel/personel/searchByStatus?${
      isNumber(params?.status) ? `status=${params?.status}` : ""
    }`
  );
};

const editTeacherBranch = (params) => {
  return apiInstance.put("/enpersoneldetail/teacher/branch", params);
};

const getSchoolTeachers = (schoolId) => {
  return apiInstance.post(`/enpersonel/teacher/get/${schoolId}`);
};

const getSchoolTeachersByBranch = ({ schoolId, baseBranchId, branchId }) => {
  return apiInstance.get(`/enpersonel/teacher/get/${schoolId}/${baseBranchId}/${branchId}`);
};

const searchTeacherGet = () => {
  return apiInstance.post(`/enpersonel/teacher/get`);
};

const searchPersonelByRole = (roleIdList) => {
  return apiInstance.post(`/enpersonel/getByRoleIds`, roleIdList);
};

const getGroupPersonnels = (groupId) => {
  return apiInstance.post(`/enpersonel/personel/group/${groupId}`);
};

const getPersonnelInfoView = (userRoleId) => {
  return apiInstance.get(`/enpersonel/personel/search/info/${userRoleId}`);
};

const searchPersonnelViewByText = (text) => {
  return apiInstance.get(`/enpersonel/searchPersonnelByText/${text}`);
};

const updatePersonnelPermittedTerms = ({ termIdList, userId, userRoleId }) => {
  return apiInstance.post(
    `enpersonel/permittedTerms?userId=${userId}${userRoleId ? `&userRoleId=${userRoleId}` : ""}`,
    termIdList
  );
};

const getPersonnelPermittedTerms = ({ userId, userRoleId }) => {
  return apiInstance.get(
    `enpersonel/permittedTerms?${userId ? `userId=${userId}` : ""}${
      userRoleId ? `&userRoleId=${userRoleId}` : ""
    }`
  );
};

export {
  addPersonel,
  addRoleToPersonel,
  deleteRoleFromPersonnel,
  editPersonelOperation,
  searchTeacher,
  deletePersonnel,
  getPersonelByDomainTypeAndDomainId,
  searchPersonel2,
  editTeacherBranch,
  getSchoolTeachers,
  searchTeacherGet,
  searchPersonelByRole,
  getGroupPersonnels,
  getPersonnelInfoView,
  searchPersonnelViewByText,
  getSchoolTeachersByBranch,
  getPersonnelPermittedTerms,
  updatePersonnelPermittedTerms,
  searchPersonel2ByStatus,
  setStatus,
  getPersonelByDomainType
};
